export default "__VITE_ASSET__AdNRz6ZV__"